// extracted by mini-css-extract-plugin
module.exports = {"column":"referralFarmsSkeleton_column__1o50x","firstColumn":"referralFarmsSkeleton_firstColumn__3PwM1"};